import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-account-created",
    templateUrl: "./account-created.component.html",
    styleUrls: ["./account-created.component.scss"],
    standalone: false
})
export class AccountCreatedComponent {
  createAccount: boolean;
  activeTheme: any;
  accountType: string;
  userId: any;

  constructor(
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private router: Router,
    private route: ActivatedRoute,
    private api: ZpDataService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const createAccount = params["createAccount"] === "true";
      const accountType = params["accountType"];
      this.userId = params["userId"];
      console.log("userId:", this.userId);
      console.log("createAccount:", createAccount);

      if (createAccount) {
        console.log("createAccount is true");
        this.createAccount = true;
      } else {
        console.log("createAccount is false");
        this.createAccount = false;
      }
      if (accountType == "invite-only") {
        this.accountType = "invite-only";
      }
      if (accountType == "upload-professionals-list") {
        this.accountType = "upload-professionals-list";
      }
    });
    this.activeTheme = this.themeService.active;
  }

  returnHome() {
    console.log("accountType:", this.accountType);
    if (this.accountType == "invite-only") {
      this.router.navigate(["/shared-plan-summary/" + this.userId]);
    }

    if (this.accountType == "upload-professionals-list") {
      this.router.navigate(["/professional-home-page"], {
        queryParams: {
          redirectToAccountsCreated: true,
        },
      });
    }
  }
}
